import { gql } from "@apollo/client";
import { TRIP_FIELDS_FRAGMENT } from "../../../common/model/fieldsFragment";


export const QR_LIST_TRIP_PUBLICATION = gql`
  query GetTripPublicationList(
    $paginationParams: BaseCollection!
    $establishmentIds: [String!]
    $search: String
    $status: TripPublicationStatusEnum
  ) {
    QR_LIST_TRIP_PUBLICATION(
      paginationParams: $paginationParams
      establishmentIds: $establishmentIds
      search: $search
      status: $status
    ) {
      code
      data {
        totalElements
        totalPages
        currentPage
        content {
          id
          tripId
          status
          tripDates {
          seatsAvailable {  
            numberOfSeatsAvailable
            numberOfChildrensSeatsAvailable
            numberOfBabiesSeatsAvailable
          }
            }
          trip {
            title
            reference
            establishment {
              id
              company {
                legalName
              }
            }
            
          }
        }
      }
    }
  }
`;

// Nom de l'opération de QR_LIST_TRIP_PUBLICATION : utilisé pour relancer la liste
// depuis une mutation (refetchQueries).
export const LIST_TRIP_PUBLICATION_OPERATION = "GetTripPublicationList";

export const DELETE_TRIP_PUBLICATION = gql`
  mutation DeleteTripPublication($tripPublicationId: String!) {
    MT_DELETE_TRIP_PUBLICATION(tripPublicationId: $tripPublicationId) {
      code
      error {
        message
        correlationId
      }
    }
  }
`;

export const PUBLISH_TRIP = gql`
  mutation PublishTrip($tripPublicationId: String!) {
    MT_PUBLISH_TRIP_PUBLICATION(tripPublicationId: $tripPublicationId)
  }
`;

export const UPDATE_TRIP_PUBLICATION = gql`
  mutation UpdateTripPublication(
    $tripPublicationId: String!
    $tripPublicationInput: TripPublicationInput!
  ) {
    MT_UPDATE_TRIP_PUBLICATION(
      tripPublicationId: $tripPublicationId
      tripPublicationInput: $tripPublicationInput
    ) {
      code
      error {
        timestamp
        message
        correlationId
      }
    }
  }
`;

export const GET_TRIP_PUBLICATION = gql`
  query QR_GET_TRIP_PUBLICATION($tripPublicationId: String!) {
    QR_GET_TRIP_PUBLICATION(tripPublicationId: $tripPublicationId) {
      code
      data {
        id
        tripId
        status
        childsMaxAge
        babiesMaxAge
        tripDates {
          id
          startDate
          endDate
          nbDays
          nbNight
          isCheapestDate
          isFlightIncluded
          stepsDate {
            date
            stepIds
          }
          adultPricePerPerson {
            value
            currency
          }
          childPricePerPerson {
            value
            currency
          }
          babiesPricePerPerson {
            value
            currency
          }
          seatsAvailable {
            initialNumberOfSeatsAvailable
            initialNumberOfChildrensSeatsAvailable
            initialNumberOfBabiesSeatsAvailable
            numberOfSeatsAvailable
            numberOfChildrensSeatsAvailable
            numberOfBabiesSeatsAvailable
          }
          flightItinerary {
            outboundFlight {
              isFlightWithStopover
              flights {
                description
                departureFlightCity
                departureFlightCountry
                departureFlightAirport
                departureFlightAirportCode
                departureFlightTerminal
                departureFlightTime
                arrivalFlightCity
                arrivalFlightCountry
                arrivalFlightAirport
                arrivalFlightAirportCode
                arrivalFlightTerminal
                arrivalFlightTime
                flightNumber
                flightBaggageInformation
                flightCompany
                flightCompanyLogo
                flightDuration
                stopOverDuration
                flightDate
              }
            }
            returnFlight {
              isFlightWithStopover
              flights {
                description
                departureFlightCity
                departureFlightCountry
                departureFlightAirport
                departureFlightAirportCode
                departureFlightTerminal
                departureFlightTime
                arrivalFlightCity
                arrivalFlightCountry
                arrivalFlightAirport
                arrivalFlightAirportCode
                arrivalFlightTerminal
                arrivalFlightTime
                flightNumber
                flightBaggageInformation
                flightCompany
                flightCompanyLogo
                flightDuration
                stopOverDuration
                flightDate
              }
            }
          }
          travelManagers {
            fullName
            email
            phoneNumber {
              indicative
              number
            }
          }
        }
        trip {
          tripProgramDetails {
            id
            ranking {
              title
            }
          }
        }
      }
      error {
        timestamp
        message
        correlationId
      }
    }
  }
`;

export const GET_TRIP = gql`
  query QR_GET_TRIP($tripId: String!) {
    QR_GET_TRIP(tripId: $tripId) {
      code
      data {
        id
        reference
        establishmentId
        title
        smallDescription
        detailedDescription
        tripProgramDetails {
          id
          ranking {
            id
            rank
            title
          }
          picture {
            id
            link
            isMain
          }
          city
          country
          latitude
          longitude
          stay
          hosting {
            id
            name
            stars
          }
          description
          activities {
            id
            title
            picture
            description
            adultPricePerPerson {
              id
              value
              currency
            }
            childPricePerPerson {
              id
              value
              currency
            }
            babiesPricePerPerson {
              id
              value
              currency
            }
            isIncluded
          }
          options {
            id
            picture
            title
            description
            adultPricePerPerson {
              id
              value
              currency
            }
            childPricePerPerson {
              id
              value
              currency
            }
            babiesPricePerPerson {
              id
              value
              currency
            }
          }
        }
      }
      error {
        timestamp
        message
        correlationId
      }
    }
  }
`;

export const ADD_TRIP = gql`
  mutation MT_ADD_TRIP($tripInput: TripInput!) {
    MT_ADD_TRIP(tripInput: $tripInput) {
      code
      data {
        ...TripFields
      }
      error {
        message
        timestamp
        correlationId
      }
    }
  }
  ${TRIP_FIELDS_FRAGMENT}
`;

export const UPDATE_TRIP = gql`
  mutation UpdateTrip($tripId: String!, $tripInput: TripInput!) {
    MT_UPDATE_TRIP(tripId: $tripId, tripInput: $tripInput) {
      code
      data {
        ...TripFields
      }
      error {
        message
        timestamp
        correlationId
      }
    }
  }
  ${TRIP_FIELDS_FRAGMENT}
`;
